export enum AtiraLinkPlanStats {
  PLAN_0 = '30',
  PLAN_1 = '90',
  PLAN_2 = '360',
}
